import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { Container, Point } from "pixi.js";

export interface IScrollBarControllerOptions {
    onused: (positionY: number) => void;
}

export class ScrollBarController extends AnimationBaseController {
    $model: any;

    public slider: Container;
    public background: Container;

    public constructor(
        @Inject private _options: IScrollBarControllerOptions,
    ) {
        super('ScrollBarController');
    }

    public setSliderPosition(y: number): number {
        if (y < -this.background.height / 2) {
            y = -this.background.height / 2;
        }
        if (y > this.background.height / 2 - this.slider.height) {
            y = this.background.height / 2 - this.slider.height;
        }
        
        this.slider.y = y;

        return y;
    }

    public resetSliderPosition(): void {
        this.slider.y = -this.background.height / 2;
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration> {
            childControllers: {}
        }
    }

    protected onInitialize(): void {
        this.background = this.getDisplayObjectByQuery('slider_bg')[0] as Container;
        this.slider = this.getDisplayObjectByQuery('slider')[0] as Container;
        this.slider.interactive = true;
        this.slider.buttonMode = true;

        let startY = 0;
        let sliderY = 0;
        let dragging = false;
        this.slider.on('pointerdown', (event) => {
            startY = event.data.getLocalPosition(this.background, new Point(), event.data.global).y;
            sliderY = this.slider.y;
            dragging = true;
        })
        .on('pointerup', () => {
            dragging = false;
        })
        .on('mouseupoutside', () => {
            dragging = false;
        })
        .on('pointermove', (event) => {
            if (!dragging) {
                return;
            }

            const currentY = event.data.getLocalPosition(this.background, new Point(), event.data.global).y;
            let y = this.setSliderPosition(sliderY - (startY - currentY));

            if (this._options.onused) {
                this._options.onused(y);
            }
        })
    }
}
